<template>
  <div class="weeklist-wrap">
    <van-row
      v-if="weeks && weeks.length > 0"
      class="search"
      gutter="15"
      type="flex"
      align="center"
    >
      <van-col>
        <div>选择周期</div>
      </van-col>
      <van-col>
        <div class="search-item" @click="weekPicker = true">
          <span>{{ weekText }}</span>
          <van-icon name="arrow-down" />
        </div>
      </van-col>
    </van-row>
    <!-- <van-row
      v-if="person && person.account"
      class="person-rank"
      type="flex"
      align="center"
    >
      <van-col span="4">
        <div class="avator">
          <img :src="person.avatar || '@/assets/default-avatar.png'" />
        </div>
      </van-col>
      <van-col span="6">
        <div class="rank-label">我的排名</div>
        <div class="rank-data">{{ person.num }}</div>
      </van-col>
      <van-col span="6">
        <div class="rank-label">得分</div>
        <div class="rank-data">{{ person.score }}</div>
      </van-col>
      <van-col span="8">
        <div class="rank-label">用时</div>
        <div class="rank-data">{{ person.duration_format }}</div>
      </van-col>
    </van-row> -->
    <div class="tips">温馨提示：榜单排名实时更新</div>
    <empty v-if="loading === false && list.length === 0" :tag="false" />
    <template v-else>
      <div class="custom-table">
        <div class="custom-thead">
          <van-row style="text-align: center">
            <van-col span="4">排名</van-col>
            <van-col span="10">用户帐号</van-col>
            <van-col span="4">得分</van-col>
            <van-col span="6">用时</van-col>
          </van-row>
        </div>
        <div class="custom-tbody stripe">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="仅展示前100名参赛用户"
            @load="getData"
          >
            <van-row
              v-for="(item, index) in list"
              :key="index"
              style="text-align: center"
            >
              <van-col span="4">{{ index + 1 }}</van-col>
              <van-col span="10">
                <div class="account-msg">
                  <div><img :src="item.avatar" /></div>
                  <span>{{ item.account }}</span>
                </div>
              </van-col>
              <van-col span="4">{{ item.score }}</van-col>
              <van-col span="6">{{ item.duration_format }}</van-col>
            </van-row>
          </van-list>
        </div>
      </div>
    </template>
    <van-popup
      v-model="weekPicker"
      round
      position="bottom"
      get-container="body"
    >
      <van-picker
        title=""
        show-toolbar
        :columns="weeks"
        @cancel="weekPicker = false"
        @confirm="weekConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import Empty from "./Empty";
import dayjs from "dayjs";
export default {
  components: {
    Empty,
  },
  props: {
    weeks: {
      type: Array,
      require: true,
    },
  },
  data() {
    return {
      // 列表
      // person: {},
      list: [],
      loading: false,
      currentPage: 1,
      finished: false,
      week: dayjs().week(),
      // weekText: "全部时段",
      weekPicker: false,
    };
  },
  computed: {
    weekText() {
      return this.weeks[this.weeks.findIndex((x) => x.code == this.week)].text;
    },
  },
  methods: {
    // 获取个人数据数据
    async getData() {
      try {
        this.loading = true;
        const res = await this.$axios.post(`/Statis/statsUserWeek `, {
          page: this.currentPage,
          size: 100,
          week: this.week,
        });
        if (res.data && res.data.list.length > 0) {
          res.data.list.forEach((element) => {
            this.list.push(element);
          });
          // this.currentPage++;
        }
        this.loading = false;
        // if (this.list.length >= Number(res.data.total)) {
        this.finished = true;
        // }
        // if (!this.person || !this.person.account) {
        // this.person = { ...res.data.own };
        // }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || `获取数据失败`,
          duration: 2000,
        });
      } finally {
        this.loading = false;
      }
    },
    //
    // async getPersonalData() {
    //   try {
    //     const res = await this.$axios.post(`/Statis/getStatsUser`);
    //     this.person = res?.data ?? null;
    //   } catch (error) {
    //     this.$notify({
    //       type: "danger",
    //       message: error.errorMsg || "获取数据失败",
    //       duration: 2000,
    //     });
    //   }
    // },
    typeConfirm(value) {
      this.finished = false;
      this.loading = false;
      this.list = [];
      this.currentPage = 1;
      this.type = value.code;
      this.getData();
      this.typePicker = false;
    },
    weekConfirm(value) {
      this.finished = false;
      this.loading = false;
      this.list = [];
      this.currentPage = 1;
      this.week = value.code;
      this.weekText = value.text;
      this.getData();
      this.weekPicker = false;
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="scss" scoped>
.weeklist-wrap {
  .search {
    margin: 15px 20px;
    font-size: 14px;
    color: #333;
    .search-item {
      width: 230px;
      padding: 7px 10px;
      color: #999;
      cursor: pointer;
      border: 1px solid #c8c8c8;
      border-radius: 4px 4px 4px 4px;
      .van-icon-arrow-down {
        color: #3b60fc;
      }
      & > span {
        margin-right: 160px;
      }
    }
  }
  .person-rank {
    padding: 6px 12px;
    margin: 12px 16px;
    border-radius: 5px 5px 5px 5px;
    box-shadow: 0 0 3px 0 rgba(150, 150, 150, 0.25);
    .avator {
      width: 38px;
      height: 38px;
      overflow: hidden;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
        vertical-align: top;
      }
    }
    .rank-label {
      margin-bottom: 8px;
      font-size: 12px;
      line-height: 15px;
      color: #333;
      text-align: center;
    }
    .rank-data {
      font-size: 14px;
      font-weight: 600;
      line-height: 15px;
      color: #0054ff;
      text-align: center;
    }
  }
  .tips {
    width: 100%;
    padding: 4px 16px;
    font-size: 12px;
    line-height: 25px;
    color: #00a3ff;
    text-align: left;
    background: rgba(0, 178, 255, 0.16);
  }

  .custom-table {
    .custom-thead,
    .custom-tbody {
      .van-row {
        padding: 0 10px;
      }
    }

    .custom-tbody {
      height: calc(100vh - 31px - 51px - 61px - 33px);
      overflow: auto;
      .account-msg {
        display: flex;
        align-items: center;
        & > div {
          width: 23px;
          height: 23px;
          margin-right: 8px;
          overflow: hidden;
          border-radius: 50%;
          img {
            width: 100%;
            vertical-align: top;
          }
        }
      }
    }
  }
}
</style>
